module.exports = __webpack_public_path__ + "img/jiaoyifengxian.872c2974.png";